import React, { useEffect, useState } from "react"

import TextField from "@/components/form/textField/TextField"
import Icon from "@/components/icon/Icon"
import { TimeUtils } from "@/app/report/components/timeSlider/timeUtils.ts"

interface TimeInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  label?: string
  min?: number
  max?: number
  format?: "HH:MM" | "HH:MM:SS" | "HH:MM:SS.ms"
  className?: string
}

export default function TimeInput({
  value,
  onChange,
  placeholder = "00:00",
  label,
  min,
  max,
  format = "HH:MM",
  className,
}: TimeInputProps) {
  const [localValue, setLocalValue] = useState(value)

  useEffect(() => {
    setLocalValue(value)
  }, [value])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setLocalValue(event.target.value)
  }

  const validateAndSubmit = () => {
    const parsedTime = TimeUtils.parse(localValue, format)

    if (parsedTime === null) {
      setLocalValue(value)
      return
    }

    if (min !== undefined && parsedTime < min) {
      setLocalValue(TimeUtils.format(min, format))
      onChange(TimeUtils.format(min, format))

      return
    }

    if (max !== undefined && parsedTime > max) {
      setLocalValue(TimeUtils.format(max, format))
      onChange(TimeUtils.format(max, format))

      return
    }

    onChange(TimeUtils.format(parsedTime, format))
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      validateAndSubmit()
      ;(event.currentTarget as HTMLElement).blur()
    }
  }

  const handleBlur = () => {
    validateAndSubmit()
  }

  return (
    <TextField
      className={className}
      label={label}
      value={localValue}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      placeholder={placeholder}
      appendIcon={<Icon type="time" />}
    />
  )
}
